exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#wacg-wrapper .v-image{z-index:0}#wacg-wrapper .v-image__image,#wacg-wrapper .v-image__placeholder{z-index:-1;position:absolute;top:0;left:0;width:100%;height:100%}#wacg-wrapper .v-image__image{background-repeat:no-repeat}#wacg-wrapper .v-image__image--preload{filter:blur(2px)}#wacg-wrapper .v-image__image--contain{background-size:contain}#wacg-wrapper .v-image__image--cover{background-size:cover}", ""]);

// exports
